import React from 'react';
import PainelRetratil from "./RatratilPainel";
import TerritoryInfoCards from "./TerritoryInfoCards";
import NucleoInfoCards from "./NucleoInfoCards";

const NoDataMessage = ({ message = "Nenhum dado a exibir para a seleção atual." }) => (
  <div style={{ padding: '15px', color: '#888', fontStyle: 'italic', fontSize: '14px', background: '#fff', borderRadius: '0px 0px 8px 8px' }}>
    {message}
  </div>
);

const PainelCasaLegal = ({
  loading,
  resumoPlanilha,
  planilhaData,
  territorioStats,
  statusCounts,
  totalVetorizados,
  onSaveRow
}) => {
  const s = statusCounts || {};

  if (loading) {
    return <p style={{ padding: '20px', textAlign: 'center' }}>Carregando dados...</p>;
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      <PainelRetratil titulo="📊 Informações Central">
        {resumoPlanilha && resumoPlanilha.total_nucleos > 0 ? (
          <div style={{ borderRadius: "0px 0px 8px 8px" }}>
            <NucleoInfoCards
              detalhesConclusao={{
                emitidos: resumoPlanilha?.total_registros_emitidos || 0,
                crdu: resumoPlanilha?.total_regularizados_externamente || 0,
                casaFechada: s["Casa Fechada"] || 0,
                coletaRecusada: s["Coleta Recusada"] || 0,
                emAndamento: Math.max(0,
                  (resumoPlanilha?.unidades_concluidas || 0) - (
                    (resumoPlanilha?.total_registros_emitidos || 0) +
                    (resumoPlanilha?.total_regularizados_externamente || 0) +
                    (s["Casa Fechada"] || 0) +
                    (s["Coleta Recusada"] || 0)
                  )
                ) - 5
              }}
              contagens={{
                "Total de Unidades": resumoPlanilha?.total_unidades || 0,
                "Municípios em atuação": resumoPlanilha?.total_municipios || 0,
                "Unidades Concluídas": resumoPlanilha?.unidades_concluidas || 0,
              }}
            />
          </div>
        ) : (
          <NoDataMessage />
        )}
      </PainelRetratil>

      <PainelRetratil titulo="🗺️ Estatísticas por Território">
        {territorioStats && Object.keys(territorioStats).length > 0 ? (
          <div style={{ background: "#fff", padding: 10, borderRadius: "0px 0px 8px 8px", boxShadow: "0 2px 6px rgba(0,0,0,0.1)" }}>
            <TerritoryInfoCards estatisticas={territorioStats} />
          </div>
        ) : (
          <NoDataMessage />
        )}
      </PainelRetratil>
    </div>
  );
};

export default PainelCasaLegal;
